import React from "react"
import { useHistory } from "react-router-dom"
import UserImage from "./UserImage"
import { Employee } from "@finway-group/shared/lib/models"
import { FINWAY_ADMIN_EMAIL } from "Shared/config/consts"
import { ConditionalWrapper } from "./conditionalWrapper"

interface EmployeeLinkInterface {
    employee: Employee
}
const EmployeeLink: React.FC<EmployeeLinkInterface> = ({ employee }) => {
    const history = useHistory()

    const { id, email, firstName, lastName } = employee

    const path = `/employees/${id}`

    const onClick = (event: any) => {
        event.preventDefault()
        history.push({ pathname: path })
    }

    return (
        <ConditionalWrapper
            condition={email !== FINWAY_ADMIN_EMAIL}
            wrapper={(children: any) => (
                <a href={path} onClick={onClick} className="flex items-center justify-end">
                    {children}
                </a>
            )}
        >
            <div className="flex items-center flex-no-wrap">
                <UserImage user={employee} />
                <span className="leading-tight truncate">
                    {firstName} {lastName}
                </span>
            </div>
        </ConditionalWrapper>
    )
}

export default EmployeeLink
